
import { defineComponent, ref, Ref, onMounted, inject } from "vue";
import axios from "axios";
import { store } from "@/store";
import CloseSVG from "@/components/CloseSVG.vue";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "ForgotPassword",
  components: {
    CloseSVG,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const title = ref("");
    onMounted(() => {
      //Trigger rerender on mount
      title.value = "Forgot Password?";
    });

    const returnToLogin = () => {
      store.dispatch(ActionTypes.SET_MODAL, "loginModal");
    };

    const emailInput = ref("");
    const errorMessage = ref("");
    const showErrorMessage = ref(false);
    const showInvalidEmailError = ref(false);

    /* eslint-disable no-useless-escape */
    const validateEmail = (email: string) => {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    };

    const loading = ref(false);
    const handleReset = async () => {
      loading.value = true;

      if (validateEmail(emailInput.value)) {
        try {
          let res = await axios.post(
            `${process.env.VUE_APP_API_URL}/editor/customers/ajax.php?mode=forgotPassword`,
            { email: emailInput.value }
          );

          if (typeof res.data.error !== "undefined") {
            if (res.data.message.includes("email does not have an account")) {
              showInvalidEmailError.value = true;
              showErrorMessage.value = false;
            } else {
              errorMessage.value = res.data.message;
              showErrorMessage.value = true;
            }
          } else {
            showErrorMessage.value = false;
            closeModal();
          }

          loading.value = false;
        } catch (e) {
          console.log(e);
          loading.value = false;
        }
      } else {
        errorMessage.value = "Please enter a valid email";
        showErrorMessage.value = true;
        loading.value = false;
      }
    };

    return {
      closeModal,
      fadeTransition,
      bounceTransition,
      title,
      returnToLogin,
      emailInput,
      errorMessage,
      showErrorMessage,
      showInvalidEmailError,
      loading,
      handleReset,
    };
  },
});
